exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnail[data-v-352200cc]{border:1px solid #e6e6e6}.thumbnail .caption[data-v-352200cc]{padding:5px 10px 0}.thumbnail .caption h3[data-v-352200cc]{text-align:center;padding:15px 0}.no-logo[data-v-352200cc]{position:relative}.no-logo img[data-v-352200cc]{width:100%}.no-logo h4[data-v-352200cc]{position:absolute;top:35%;text-align:center;width:100%;color:#057aff;font-size:30px;text-shadow:2px 8px 8px hsla(0,0%,83%,.5),2px -6px 25px #000}button[data-v-352200cc]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-352200cc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/common/ss_catalog_item.vue
// module id = xJ3V
// module chunks = 0